/**
 * Resolve a path that lives in `public/` against the bundle's own base.
 *
 * The stylesheets get this for free — Vite rewrites `url("/v07/fonts/…")` in CSS according to the
 * configured `base`. String literals in TypeScript it cannot rewrite, so a hard-coded
 * `/v07/fonts/Poppins-Regular.ttf` only resolves when the bundle is served from the origin root.
 * The demo build sets `base: './'` so it can also be served from a sub-path (a published preview
 * is), and there a leading slash points outside the deployment and 404s — which would silently
 * cost every PNG/print export its Poppins faces and fall back to a different typeface.
 *
 * `import.meta.env.BASE_URL` is the base Vite built with: `/` for the application build, `./` for
 * the demo build. Joining against it keeps both correct.
 */
export function publicAssetUrl(path: string): string {
  const base = import.meta.env.BASE_URL;
  const rel = path.replace(/^\/+/, '');
  return base.endsWith('/') ? `${base}${rel}` : `${base}/${rel}`;
}
